var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamLeadBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Badge",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313 313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".badge-cls-1{fill:#94effd;}.badge-cls-2{fill:#14163d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Team Lead Badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "badge-cls-1",
    cx: 156.5,
    cy: 156.5,
    r: 156.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "badge-cls-2",
    cx: 157,
    cy: 156,
    r: 142
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "badge-cls-1",
    d: "M47.27,163.52l6.7,1.71,46.8,12c6.63,1.7,13.26,3.39,19.88,5.14a1.51,1.51,0,0,0,1.9-.65c4.89-6.55,9.83-13.07,14.75-19.6l37.25-49.36a.48.48,0,0,1,.36-.21c-.11.22-.22.44-.34.65-8.78,16.74-17.34,33.59-25.28,50.75a278.38,278.38,0,0,0-11,26.35A43.89,43.89,0,0,0,136,199a3.18,3.18,0,0,0,.34,1.92,54.66,54.66,0,0,0,6,9.07,185.47,185.47,0,0,0,17.42,18.69c2.88,2.76,5.84,5.43,8.78,8.13a1.46,1.46,0,0,0,.33.17l-.16.21c-1.28-.67-2.57-1.31-3.84-2a147.24,147.24,0,0,1-30.67-22.7,157.91,157.91,0,0,1-16.71-18.73,2.43,2.43,0,0,0-1.08-.71l-48.43-17q-7.06-2.48-14.13-5a2.3,2.3,0,0,1-1-.61c-1.82-2.19-3.6-4.42-5.4-6.63C47.47,163.84,47.41,163.73,47.27,163.52Z",
    transform: "translate(-23 -24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "badge-cls-1",
    d: "M185.21,237.11c1.45-1.33,2.92-2.64,4.37-4A210.32,210.32,0,0,0,210.83,211c2.2-2.76,4.07-5.78,6.13-8.66a6,6,0,0,0,.8-5.2,94.36,94.36,0,0,0-4.49-13.65c-4.37-11-9.33-21.78-14.6-32.4-6.33-12.76-12.86-25.43-19.3-38.14a.85.85,0,0,1-.12-.49c.11.12.23.23.33.36l32.18,42.66,19.7,26.1c.78,1,.78,1,2.11.69l41.77-10.71,31.42-8.05c-.15.23-.23.39-.33.52-1.73,2.14-3.46,4.28-5.21,6.4a2.21,2.21,0,0,1-.94.66q-28.8,10.11-57.59,20.17c-1.75.61-3.51,1.21-5.24,1.86a2.38,2.38,0,0,0-1,.77,153.93,153.93,0,0,1-42.1,38.28c-2.76,1.69-5.65,3.17-8.48,4.74-.19.11-.39.18-.58.27Z",
    transform: "translate(-23 -24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "badge-cls-1",
    d: "M172.66,209.45l-14.18,8.12-.13-.1,8.12-14.21L145.05,199v-.15l21.43-4.3c-2.74-4.8-5.43-9.49-8.11-14.19l.09-.12,14.23,8.13c1.44-19.57,2.86-39,4.29-58.37h.13c1.42,19.41,2.85,38.81,4.28,58.38l14.23-8.13.11.11-8.13,14.2L209,198.81V199l-21.42,4.29,8.13,14.21-.12.1-14.2-8.12c-1.45,7.22-2.87,14.32-4.29,21.42H177C175.53,223.79,174.11,216.7,172.66,209.45Z",
    transform: "translate(-23 -24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "badge-cls-1",
    d: "M186,237s31-19,51-44l66-25-38,50Z",
    transform: "translate(-23 -24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "badge-cls-1",
    d: "M169,237s-31-21-51-46L50,167l39,50Z",
    transform: "translate(-23 -24)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamLeadBadge);
export default __webpack_public_path__ + "static/media/TeamLeadBadge.b6e34432371d91971985976ea4734984.svg";
export { ForwardRef as ReactComponent };